import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('billing');

export class Invoice extends Api {
  constructor(http, config = {}) {
    super(http, url, 'billing', config);
  }

  getInvoiceById (invoiceId = null, asReceipt = false, config = {}) {
    config = {...this._config, ...config};
    const uri = `${url}/odoo/invoices/${invoiceId}/download?asReceipt=${asReceipt}`
    return this._http.get(uri, config);
  }
}
